import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { AgGrid, gridConstants as gc, filterParams, filters } from '../../../components/AgGrid';
import classnames from 'classnames';
import { IndividualAccountingHistoryDetail } from '../../../components/Accounting';
import { Autocomplete } from '../../../components/Autocomplete';
import { monthsOptions, getInitialReportMonth } from '../../../helpers/constants/months';
import { generateRecentReportPeriods, getReportPeriod } from '../../../helpers/constants/payroll';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

// SERVICES
import { getIndividualPaymentsReportHistory, getIndividualPaymentsHistoryPeriods } from '../../../services';

const styles = theme => ({});

const radios = {
  ALL: 'ALL',
  PERIODS: 'PERIODS',
};

export const IndividualAccountingHistory = withStyles(styles)(props => {
  const { classes, reportType } = props;

  // const [reportMonth, setReportMonth] = useState(getInitialReportMonth);
  const [selectedRadio, setSelectedRadio] = useState(radios.PERIODS);
  const [gridData, setGridData] = useState(null);
  // const [reportPeriods, setReportPeriods] = useState(generateRecentReportPeriods);
  // const [reportPeriod, setReportPeriod] = useState(getReportPeriod);
  const [reportPeriod, setReportPeriod] = useState(null);
  const [periodOptions, setPeriodOptions] = useState(null);

  const columnDefs = [
    {
      headerName: 'User',
      field: 'user',
    },
    {
      headerName: 'WingpsanId',
      field: 'wingspanId',
    },
    {
      headerName: 'Email',
      field: 'email',
    },
    {
      headerName: 'Payment ID',
      field: 'paymentId',
      cellRenderer: 'agGroupCellRenderer',
    },
    {
      headerName: '# of Orders',
      valueGetter: ({ data }) => data.paymentOrderlineDetail.length,
      cellRenderer: ({ data }) => data.paymentOrderlineDetail.length,
    },
    {
      headerName: 'Period',
      field: 'period',
    },
    {
      headerName: 'Payment Total ($)',
      field: 'paymentTotal',
    },
    {
      headerName: 'Payment Due Date',
      field: 'paymentDueDate',
      width: gc.DATE_FIELD_WIDTH,
      cellRenderer: 'dateUTC',
      filter: filters.date,
      filterParams: filterParams.date,
      enablePivot: true,
    },
    {
      headerName: 'Payment Date',
      field: 'paymentDate',
      width: gc.DATE_FIELD_WIDTH,
      cellRenderer: 'dateUTC',
      filter: filters.date,
      filterParams: filterParams.date,
      enablePivot: true,
    },
    // {
    //   headerName: 'Type',
    //   field: 'type',
    // },
  ];

  const gridOptions = {
    masterDetail: true,
    detailCellRenderer: 'IndividualAccountingHistoryDetail',
    detailRowHeight: 460,
    frameworkComponents: {
      IndividualAccountingHistoryDetail: params => {
        const { paymentOrderlineDetail } = params.data;
        return <IndividualAccountingHistoryDetail gridData={paymentOrderlineDetail} />;
      },
    },
  };

  const getIndividualPaymentsHistoryPeriodsAsync = async () => {
    try {
      const periods = await getIndividualPaymentsHistoryPeriods(reportType);
      setPeriodOptions(periods);
      console.log(periods);
      setReportPeriod(periods[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const getIndividualPaymentsReportHistoryAsync = async period => {
    try {
      setGridData(null);
      const result = await getIndividualPaymentsReportHistory(period, reportType);
      setGridData(result);
    } catch (error) {
      console.log(error);
    }
  };

  // const updateSelectedRadio = ({ target: { value } }) => {
  //   setSelectedRadio(value);
  //   console.log(value);
  //   getIndividualPaymentsReportHistoryAsync(value === radios.ALL ? null : reportPeriod.label);
  // };

  useEffect(() => {
    if (reportPeriod) {
      getIndividualPaymentsReportHistoryAsync(reportPeriod.label);
    }
  }, [reportPeriod]);

  useEffect(() => {
    getIndividualPaymentsHistoryPeriodsAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center', 'card', 'border-left-green')}>
      <div className={classnames('align-stretch', 'row-start-center')} style={{ marginBottom: 15 }}>
        <div
          style={{
            minWidth: 500,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
          onClick={evt => selectedRadio === radios.PERIODS && evt.preventDefault()}
        >
          <div style={{ marginRight: 15 }}>Choose a period to view: </div>
          <div style={{ flex: 1 }}>
            <Autocomplete
              disabled={selectedRadio !== radios.PERIODS}
              options={periodOptions}
              value={reportPeriod}
              onChange={setReportPeriod}
            />
          </div>
        </div>
      </div>
      <AgGrid
        gridData={gridData}
        columnDefs={columnDefs}
        gridOptions={gridOptions}
        redirectOnClick={false}
        editOnClick={false}
      />
    </div>
  );
});
